




















































































































































































































import Component from 'vue-class-component';
import DataGrid from '@/components/DataGrid/DataGrid.vue';
import {
  DataGridColumn,
  dataGridValidationResultIsError,
  dataGridValidationResultIsRequired,
  IDataGridColumnValidatorResult,
} from '@/components/DataGrid/DataGridColumn.class';
import { DataGridOptions } from '@/components/DataGrid/DataGridOptions.class';
import BaseComponent from '@/components/BaseComponent';
import ProjectStatistics from '@/components/ProjectStatistics/ProjectStatistics.vue';
import Modal from '@/components/Modal/Modal.vue';
import Button from '@/components/Button/Button.vue';
import Dropdown from '@/components/Dropdown/Dropdown.vue';
import { getBoxList, getGridColumns } from './gridOptions/gridOptions';
import { determineFilterItems } from './statusFilterOptions';
import { isTripEditable } from './isTripEditable';
import { Trip } from '@/typing/api/tripNew.class';
import { projectTypes } from '@/store/modules/project/projectTypes';
import { ProjectInformationModalEntries } from '@/typing/projectInformationModalEntries.class';
import { ProjectStatisticsModel } from '@/components/ProjectStatistics/projectStatistics.class';
import { IReportRelationship } from '@/typing/reportRelationship.interface';
import { Report } from '@/typing/api/report.class';
import { saveStoreBackup } from '@/utils/dexieDB';
import { TripStatus } from '@/typing/enums/tripStatus.enum';
import showNotification from '@/utils/notification';
import { approveTrips, rejectTrips, submitTrips } from '@/api/data';
import { miscTypes } from '@/store/modules/misc/miscTypes';
import { IBox } from '@/typing/api/box.interface';
import { checkTripTimes } from '@/utils/validators/miscTripValidators';
import { DataGridErrorType } from '@/typing/enums/dataGridErrorType.enum';
import { EventBus } from '@/utils/eventBus/eventBus';
import { EventBusEvent } from '@/utils/eventBus/eventBusEvent.enum';
import { getState } from '@/utils/vueInstance';
import { shipTypeEnumToReadableString } from '@/utils/shipTypes';

@Component({
  components: {
    DataGrid,
    ProjectStatistics,
    Modal,
    Button,
    Dropdown,
  },
  props: {
    projectId: {
      type: String,
      required: false,
    },
    shipId: {
      type: String,
      required: false,
    },
  },
})
export default class ProjectPage extends BaseComponent {
  dColumns: DataGridColumn[] = [];
  items: Trip[] = [];
  selectedVakNummer = -1;
  gridOptions = new DataGridOptions();
  selectedStatusFilter: any = '';
  showProjectInfoModal = false;
  statusFilterOptions: any[] = [];
  tripSelection: any[] = [];
  TripStatus = TripStatus;
  showDeclineTripModal = false;
  declineTripsReason = '';
  currentProject: IReportRelationship | null = null;
  gridValidationErrors: any[] = [];
  shipTypeEnumToReadableString = shipTypeEnumToReadableString;

  get statistics(): ProjectStatisticsModel {
    if (!this.currentProject) return new ProjectStatisticsModel();

    return new ProjectStatisticsModel().fillModel(
      this.currentProject.projectId,
      this.currentProject.shipId,
      this.$state.project.projectData,
      this.selectedVakNummer
    );
  }

  get vaknummers(): any[] {
    const distinctBoxNumbers: any[] = [];
    this.trips.forEach((t: Trip) => {
      if (!distinctBoxNumbers.includes(t.boxNumber)) {
        distinctBoxNumbers.push(t.boxNumber);
      }
    });

    return distinctBoxNumbers
      .map((val: any) => {
        return {
          label: val,
          value: val,
        };
      })
      .filter((item: any) => !!item && item.label);
  }

  get projectInfoValues(): ProjectInformationModalEntries {
    if (!this.currentProject) return new ProjectInformationModalEntries();

    const data = this.$state.project.projectData;

    if (!data) {
      return new ProjectInformationModalEntries();
    }

    return new ProjectInformationModalEntries().fillValues(
      data,
      this.currentProject.projectId,
      this.currentProject.shipId
    );
  }

  get trips(): Trip[] {
    if (!this.currentProject) return [];

    const tripArrayRef = this.currentReport?.trips ?? [];
    return tripArrayRef.map((t: Trip) => new Trip(t));
  }

  get tripsRef(): Trip[] {
    if (!this.currentProject) return [];
    return this.currentReport?.trips ?? [];
  }

  get currentReport(): Report | null {
    if (!this.currentProject) return null;
    return (
      this.$state.project.projectData?.getReport(
        this.currentProject.projectId,
        this.currentProject.shipId
      ) ?? null
    );
  }

  mounted(): void {
    this.currentProject = {
      projectId: Number(this.$props.projectId),
      shipId: Number(this.$props.shipId),
    };

    this.$store.commit(
      projectTypes.mutations.SET_LAST_VISITED_PROJECT,
      this.currentProject
    );

    this.$watch(
      () => this.$state.project.boxList,
      () => this._setupGrid()
    );

    this._genericInit(true);
    this._determinePageName();
    this._setupGrid();

    this.$watch(
      () => this.currentReport,
      () => {
        this._determinePageName();
      }
    );

    this.$watch(
      () => this.gridValidationErrors,
      () => {
        if (this.tripSelection.length === 0) {
          return;
        }

        if (this.gridValidationErrors.length === 0) return;

        const tripNoWithErrors = this.gridValidationErrors.map(
          (e: IDataGridColumnValidatorResult) => {
            if (!e.itemIndex) return;
            if (
              e.errorType &&
              (e.errorType === DataGridErrorType.Warning ||
                e.errorType === DataGridErrorType.RequiredError)
            ) {
              return;
            }

            return this.trips[e.itemIndex].number;
          }
        );

        if (tripNoWithErrors.length === 0) return;

        this.tripSelection.forEach((tripNumber: number) => {
          if (!tripNoWithErrors.includes(tripNumber)) return;
          const selectionIndex = this.tripSelection.findIndex(
            (n: number) => n === tripNumber
          );

          if (selectionIndex === -1) return;

          this.tripSelection.splice(selectionIndex, 1);
        });

        (this.$refs.dataGrid as DataGrid).selectedItems = [
          ...this.tripSelection,
        ];
      }
    );

    setTimeout(() => {
      if (this.trips.length === 0 && this.isSkipper()) {
        this.addTrip();
      }

      this._dataGridValidate();
      this.$forceUpdate();
    }, 500);
  }

  closeRejectModal(): void {
    (this.$refs.declineTripsModal as Modal).closeModal();
    this.declineTripsReason = '';
  }

  onDateSelectionChange(e: any): void {
    this.correctDate(e.itemIndex, e.column.dateValueKey);
  }

  addTrip(): void {
    if (
      this.gridValidationErrors.filter(
        (e: IDataGridColumnValidatorResult) =>
          dataGridValidationResultIsRequired(e) ||
          dataGridValidationResultIsError(e)
      ).length === 0
    ) {
      this.currentReport?.addTrip();
      this._dataGridValidate();
      this.$store.dispatch(projectTypes.actions.CHECK_TO_UPDATE_REPORTS);
      if (this.isOnline && this.trips.length > 1) {
        this.$store.dispatch(projectTypes.actions.SAVE_REPORT, {
          reportRelation: this.currentProject,
        });
        this.$store.dispatch(projectTypes.actions.CHECK_TO_UPDATE_REPORTS);
      }
      saveStoreBackup();
    } else {
      showNotification(
        'Er kan geen nieuwe reis aangemaakt worden, de huidige laatste reis is incompleet of foutief ingevuld.'
      );
    }
  }

  async saveReport(submittingTrips = false): Promise<any> {
    if (!this.currentProject) return;

    this.$store.commit(miscTypes.mutations.SET_SHOW_LOADER, true);

    await new Promise((resolve: any) => setTimeout(resolve, 1500));

    this._dataGridValidate();

    const validationErrors = this.gridValidationErrors.filter(
      (e: IDataGridColumnValidatorResult) => {
        return dataGridValidationResultIsError(e);
      }
    );

    if (validationErrors.length > 0) {
      if (!submittingTrips) {
        showNotification(
          'Er zijn fouten in de invoer, de fouten moeten worden opgelost voordat de wijzigingen kunnen worden opgeslagen.'
        );
        this.$store.commit(miscTypes.mutations.SET_SHOW_LOADER, false);
      }
    }

    const result = await this.$store.dispatch(
      projectTypes.actions.SAVE_REPORT,
      { reportRelation: this.currentProject, showLoader: true }
    );

    this.$store.commit(miscTypes.mutations.SET_SHOW_LOADER, false);

    return result;
  }

  onDataGridOptionSelection(e: { value: any; itemRef: Trip }): void {
    const val = e.value;
    const boxListRef = getBoxList('Box') ?? [];
    if (boxListRef.length === 0) return;
    const accordingValueIndex = boxListRef.findIndex(
      (b: IBox) => b.boxNumber === val || b.boxName === val
    );

    if (accordingValueIndex === -1) return;

    e.itemRef.boxName = boxListRef[accordingValueIndex].boxName;
    e.itemRef.boxNumber = boxListRef[accordingValueIndex].boxNumber;
  }

  async changeStatusForTripSelection(newTripStatus: TripStatus): Promise<any> {
    if (this.tripSelection.length === 0) {
      showNotification('Er zijn geen reizen geselecteerd.');
      return;
    }

    const currentReportId: number = this.currentReport?.id as number;
    const declineReason = this.declineTripsReason;

    await this.saveReport(true);

    const toSubmitTrips: { trip: Trip; tripIndex: number }[] = [];
    this.trips.some((t: Trip, i: number) => {
      if (!this.tripSelection.includes(t.number ?? -1))
        return toSubmitTrips.length === this.tripSelection.length;

      toSubmitTrips.push({
        trip: t,
        tripIndex: i,
      });

      return toSubmitTrips.length === this.tripSelection.length;
    });

    if (toSubmitTrips.length === 0) return;

    let neededApiCall;
    let doneMessage = '';
    const apiCallArgs: any[] = [
      currentReportId,
      toSubmitTrips.flatMap((toSubmit: any) => toSubmit.trip.id),
    ];

    if (
      newTripStatus === TripStatus.OpenContractor ||
      newTripStatus === TripStatus.OpenClient
    ) {
      neededApiCall = submitTrips as any;
      doneMessage = 'Reizen ingediend';
    } else if (
      newTripStatus === TripStatus.RejectedContractor ||
      newTripStatus === TripStatus.RejectedClient
    ) {
      neededApiCall = rejectTrips as any;
      doneMessage = 'Reizen afgekeurd';
      apiCallArgs.push(declineReason);
    } else if (newTripStatus === TripStatus.ApprovedClient) {
      neededApiCall = approveTrips as any;
      doneMessage = 'Reizen goedgekeurd';
    }

    if (!neededApiCall) return;

    try {
      this.$store.commit(miscTypes.mutations.SET_SHOW_LOADER, true);
      const result = await neededApiCall(...apiCallArgs);
      if (!result.hasErrors) {
        (this.$refs.dataGrid as DataGrid).resetSelection();
        this.tripSelection = [];
        await this.$store.dispatch(projectTypes.actions.FETCH_PROJECT_DATA);
        showNotification(doneMessage);
      }
    } catch (error) {
      showNotification(
        'Er is een probleem opgetreden tijdens het verzenden, probeer het later opnieuw.'
      );
    } finally {
      this.$store.commit(miscTypes.mutations.SET_SHOW_LOADER, false);
    }
  }

  updateTrip(e: { itemIndex: number; item: Trip }): void {
    const currentlySavedTrips =
      getState().project.projectData?.getReport(
        this.currentProject?.projectId ?? 0,
        this.currentProject?.shipId ?? 0
      )?.trips ?? [];
    const currentlyKnownTrip = currentlySavedTrips[e.itemIndex];

    const tripDateChanged =
      currentlyKnownTrip && currentlyKnownTrip.date !== e.item.date;

    this.$store.dispatch(projectTypes.actions.UPDATE_TRIP, {
      projectId: this.currentProject?.projectId,
      shipId: this.currentProject?.shipId,
      itemIndex: e.itemIndex,
      trip: e.item,
    });

    if (tripDateChanged) {
      this.correctDate(e.itemIndex, 'date');
    }

    this._dataGridValidate();
  }

  onDataGridItemSelection(e: any) {
    this.tripSelection = [...e];
  }

  navigateToReportOverview(): void {
    this.$store.commit(
      projectTypes.mutations.SET_LAST_VISITED_PROJECT,
      undefined
    );
    this.$router.push({ name: 'Reports' });
  }

  correctDate(index = -1, changedDateKey: string): void {
    console.log(changedDateKey);

    let itemIndex = index;

    const keys = [
      'date',
      'startTimeDate',
      'startTimeDredgingDate',
      'endTimeDredgingDate',
      'startTimeDumpingDate',
      'endTimeDumpingDate',
    ];

    const fromKeyIndex = keys.findIndex((x) => x === changedDateKey);

    if (fromKeyIndex === -1 || fromKeyIndex === keys.length - 1) return;

    setTimeout(() => {
      (this.$refs.dataGrid as DataGrid).runDateUndefinedForItem(
        itemIndex,
        keys.filter((x, i) => i > fromKeyIndex)
      );
    }, 500);

    this.$forceUpdate();
  }

  private _dataGridValidate(): void {
    (this.$refs.dataGrid as DataGrid).validateItemsDebounced();
  }

  private _setupGrid(): void {
    this.dColumns = getGridColumns(
      this.$state.project.projectData?.getShipById(
        this.currentProject?.shipId ?? 0
      )?.maximumVolume ?? 0
    );
    this.statusFilterOptions = [...determineFilterItems(this.getRole())];
    let preselectedStatusFilterIndex = 0;
    this.selectedStatusFilter =
      this.statusFilterOptions[preselectedStatusFilterIndex];
    this.gridOptions.shownItemsFilterFunc =
      this.statusFilterOptions[preselectedStatusFilterIndex].value;
    this.gridOptions.uniqueValueKey = 'number';
    this.gridOptions.tableMinWidthCSS = '1580px';
    this.gridOptions.additionalItemValidators = [
      (t: Trip) =>
        checkTripTimes(t, Number(this.projectInfoValues.shipVolume) > 0),
    ];

    this.gridOptions.isRowSelectableFunc = (t: Trip) => {
      const tripIndex = this.trips.findIndex(
        (iteratedTrip: Trip) => iteratedTrip.number === t.number
      );
      if (tripIndex === -1) return false;

      const tripItems = this.gridValidationErrors.filter(
        (e: IDataGridColumnValidatorResult) => e.itemIndex === tripIndex
      );

      const tripErrors = tripItems.filter(
        (e: IDataGridColumnValidatorResult) =>
          dataGridValidationResultIsError(e) ||
          dataGridValidationResultIsRequired(e)
      );

      return tripErrors.length === 0;
    };

    this.gridOptions.isRowEditableFunc = (t: Trip) =>
      isTripEditable(t, this.getRole());

    this.$watch(
      () => this.selectedStatusFilter,
      (newValue: any) => {
        if (typeof newValue.value === 'function') {
          this.gridOptions.shownItemsFilterFunc = newValue.value;
        }
      }
    );
  }

  private _determinePageName(): void {
    if (this.currentProject) {
      this._setPageName(
        `${
          this.$state.project.projectData?.getProjectById(
            this.currentProject.projectId
          )?.name
        }, ${
          this.$state.project.projectData?.getShipById(
            this.currentProject.shipId
          )?.name
        }`
      );
    }
  }
}
